import { render, staticRenderFns } from "./FAQSideNav.vue?vue&type=template&id=e1c36b5c&scoped=true&"
import script from "./FAQSideNav.vue?vue&type=script&lang=js&"
export * from "./FAQSideNav.vue?vue&type=script&lang=js&"
import style0 from "./FAQSideNav.vue?vue&type=style&index=0&id=e1c36b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c36b5c",
  null
  
)

export default component.exports